import { AppBar, Toolbar, Typography } from '@mui/material/';
import Logo from '../../assets/logo/aveda-logo.svg';
import { useNavigate } from 'react-router';
import Button from '@mui/material/Button';
import URLs from '../../pages/URLs';
import { LogoWrapper, StyledImage, MenuUserAvatar } from './MenuAppBar.styles';
import { useUserStore } from '../../store';

export const MenuAppBar = () => {
  const navigate = useNavigate();
  const { user } = useUserStore();

  return (
    <AppBar position="sticky">
      <Toolbar>
        <LogoWrapper onClick={() => navigate(URLs.ROOT)}>
          <StyledImage src={Logo} alt="Avedo" />
        </LogoWrapper>
        <Typography variant="h5" component="div" fontWeight="light" flexGrow={1}>
          S.O.A.P
        </Typography>
        <Button onClick={() => navigate(URLs.Login)}>
          <MenuUserAvatar alt={user?.sourceName} src={'#'} />
        </Button>
      </Toolbar>
    </AppBar>
  );
};
